module.exports = __webpack_public_path__ + "Urbain_Tramway.jpg?01cea8521c64275612ac68aa018bf75a";


//////////////////
// WEBPACK FOOTER
// ./src/img/domaine_activite/Urbain_Tramway.jpg
// module id = 223
// module chunks = 0